import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IInformePensionesResponse } from '@shared/common/interfaces/reporte-disponible-informe-pension.interface';
import { IPropiedadesVideoIPPResponse, IValidateVideoIPPResponse } from '@shared/common/interfaces/video-ipp.interface';
import { Util } from '@shared/common/utils/util';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InformePensionesService {

  private informePensionesPromise: Promise<IInformePensionesResponse> | null = null;
  private validarIPPPromise: Promise<IValidateVideoIPPResponse> | null = null;
  private propiedadesVideoIPPPromise: Promise<IPropiedadesVideoIPPResponse> | null = null;
  private lastToken: string | null = null;

  constructor(private readonly http: HttpClient, private readonly util: Util) { }

  async getInformePensiones(token: string, periodo:string): Promise<IInformePensionesResponse> {
    if (this.informePensionesPromise && this.lastToken === token) {
      return this.informePensionesPromise;
    }

    const url = `${environment.BASE_BACKEND}/client/informe-pensiones`;
    const headers = this.util.getHeaders(token);
    const data = {
      periodo
    };

    this.lastToken = token;

    this.informePensionesPromise = firstValueFrom(this.http.post<IInformePensionesResponse>(url, data, {
      headers
    })).finally(() => {
      // Limpiar la promesa después de que se complete (éxito o error)
      this.informePensionesPromise = null;
      this.lastToken = null;
    });

    return this.informePensionesPromise;
  }

  async getValidarVideoIPP(token: string): Promise<IValidateVideoIPPResponse> {
    if (this.validarIPPPromise && this.lastToken === token) {
      return this.validarIPPPromise;
    }

    const url = `${environment.BASE_BACKEND}/client/validar-video-ipp`;
    const headers = this.util.getHeaders(token);

    this.lastToken = token;

    this.validarIPPPromise = firstValueFrom(this.http.post<IValidateVideoIPPResponse>(url, null, {
      headers
    })).finally(() => {
      // Limpiar la promesa después de que se complete (éxito o error)
      this.validarIPPPromise = null;
      this.lastToken = null;
    });

    return this.validarIPPPromise;
  }

  async getPropiedadesVideoIPP(token: string): Promise<IPropiedadesVideoIPPResponse> {
    if (this.propiedadesVideoIPPPromise && this.lastToken === token) {
      return this.propiedadesVideoIPPPromise;
    }

    const url = `${environment.BASE_BACKEND}/client/propiedades-video-ipp`;
    const headers = this.util.getHeaders(token);

    this.lastToken = token;

    this.propiedadesVideoIPPPromise = firstValueFrom(this.http.post<IPropiedadesVideoIPPResponse>(url, null, {
      headers
    })).finally(() => {
      // Limpiar la promesa después de que se complete (éxito o error)
      this.propiedadesVideoIPPPromise = null;
      this.lastToken = null;
    });

    return this.propiedadesVideoIPPPromise;
  }
}